import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCode = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1231 23H7.37685C5.51143 23 4 21.5018 4 19.6527V4.34732C4 2.49822 5.51143 1 7.37685 1H15.8423L20.5 5.63778V19.6527C20.5 21.5018 18.9886 23 17.1231 23Z",
			fill: "#596C89"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M20.5 5.63778H16.7994C16.2755 5.63778 15.8493 5.21763 15.8493 4.69822L15.8423 1",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.82661 14.6454L6.82471 13.3227V12.8171L9.82661 11.3281V12.203L7.98448 13.0364L9.82661 13.7774V14.6454Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1694 14.6454L18.1713 13.3227V12.8171L15.1694 11.3281V12.203L17.0116 13.0364L15.1694 13.7774V14.6454Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.142 10.1509L11.883 16.3076H10.856L13.115 10.1509H14.142Z",
			fill: "white"
		})
	]
});
export default SvgCode;
